import React, { Component } from "react";
import KeyHandler, { KEYDOWN } from "react-key-handler";

import AsyncImage from "../../AsyncImage";

import chevronRight from "./chevron-right.svg";
import chevronLeft from "./chevron-left.svg";
import crossIcon from "./cross-icon.svg";

import styles from "./fullscreen.module.css";

class FullScreenContainer extends Component {
  state = {
    activeIndex: this.props.activeIndex
  };

  goForward = () => {
    const { images } = this.props;
    const { activeIndex } = this.state;
    const maxIndex = images.length - 1;

    if (activeIndex === maxIndex) {
      this.setState({
        activeIndex: 0
      });
    } else {
      this.setState({
        activeIndex: activeIndex + 1
      });
    }
  };

  goBack = () => {
    const { images } = this.props;
    const { activeIndex } = this.state;
    const maxIndex = images.length - 1;

    if (activeIndex === 0) {
      this.setState({
        activeIndex: maxIndex
      });
    } else {
      this.setState({
        activeIndex: activeIndex - 1
      });
    }
  };

  render() {
    const { activeIndex } = this.state;
    const { images } = this.props;

    return (
      <div className={styles.dimmer}>
        <KeyHandler
          keyEventName={KEYDOWN}
          keyValue="ArrowLeft"
          onKeyHandle={() => this.goBack()}
        />
        <KeyHandler
          keyEventName={KEYDOWN}
          keyValue="ArrowRight"
          onKeyHandle={() => this.goForward()}
        />
        <KeyHandler
          keyEventName={KEYDOWN}
          keyValue="Escape"
          onKeyHandle={() => this.props.closeFullScreen()}
        />

        <div className={styles.imageContainer}>
          <div onClick={this.goForward} className={styles.forwardBtn}>
            <img
              className={styles.svgButton}
              src={chevronRight}
              alt="back-button"
            />
          </div>
          <div className={styles.backBtn} onClick={this.goBack}>
            <img
              className={styles.svgButton}
              src={chevronLeft}
              alt="forward-button"
            />
          </div>
          <div className={styles.closeBtn} onClick={this.props.closeFullScreen}>
            <img
              className={styles.closeBtnSvg}
              src={crossIcon}
              alt="close-button"
            />
          </div>
          <AsyncImage
            imageUrl={images[activeIndex].file.url}
            alt={images[activeIndex].description}
            placeholderColor="#ecf0f1"
            imageClassName={styles.imageContainer}
          />
        </div>
      </div>
    );
  }
}

export default FullScreenContainer;



// WEBPACK FOOTER //
// ./src/components/Galerija/FullScreen/FullScreenContainer.js